import React, { Component } from 'react'

import database from '../config'
import Navbar from '../components/Navbar'
import Form from '../components/EditDataForm'

class EditData extends Component {
  state = {
    datum: {},
    isLoaded: false
  }

  componentDidMount() {
    database.ref(`/${this.props.match.params.id}`).once('value')
      .then(snapshot => {
        let obj = {
          id: snapshot.key,
          url: snapshot.val().url,
          email: snapshot.val().email,
          password: snapshot.val().password,
          user: snapshot.val().user,
          createdAt: snapshot.val().createdAt,
          updatedAt: snapshot.val().updatedAt
        }

        this.setState({
          datum: obj,
          isLoaded: true
        })
      })
  }

  render() {
    return (
      <div>
        <Navbar/>
        { this.state.isLoaded ? <Form item={this.state.datum} {...this.props}/> : <div className="mt-5 pt-5"> <div className="loader"></div> </div> }
      </div>
    )
  }
}

export default EditData

